export const styles = {
  pageContentWrapper: "px-5 py-5 pt-28 bg-white",
  pageHeader: "prose prose-base", //DaisuUI typography class
  modalContent: "card-body p-3",
  modalHeader: "mb-2 text-2xl font-bold tracking-tight text-gray-900",
  modalText: "font-normal text-gray-900 mb-4",
  questionText: "font-semibold text-primary text-sm",
};
